import React from 'react'

import projects from '../data/projects';

import './projects.css'


const Projects = () => {


  return (
    <>
    <section className="top-section projects">
        <div className="overlay">
        <div className="column">
          <h1>Projects</h1>
        </div>
      </div>
    </section>
    <section className="projects-section-2">
        {projects.map((project) => (
            <div id={project.sid} key={project.id} className="project-container">
            <div className="text-container">
                <h2>{project.title}</h2>
                <p>{project.text}</p>
            </div>
            <div className="line"/>
            <div className="images-container">
                {project.images.map((image) => (
                    <div className="image-container" style={{backgroundImage:`url("${image}"`}}>
                    </div>
                ))}
            </div>
        </div>
        ))}
    </section>

    </>
  )
}

export default Projects